export const sortObjectsByZindex = (fabricJS) => {
    let objectArray = fabricJS.getObjects();
    let sortedObjectArray = objectArray.sort(function(a, b) {
        return a.zIndex - b.zIndex;
    });
    sortedObjectArray.forEach((object)=>{
        object.bringToFront();
    })
}
